import { observable, action } from "mobx";
import { Configuracao } from "../../../services";
import { error, success } from "../../../utils/MensagemUtil";
import * as util from "../../../utils/MascaraUtil";

class EncargosSociaisMaoObraStore {
  @observable
  encargos = [];

  @observable
  verificador = false;

  @observable
  grupos = [];

  @observable
  totalGeralPercentualHoristaComDesoneracao = 0.0;

  @observable
  totalGeralPercentualMensalistaComDesoneracao = 0.0;

  @observable
  totalGeralPercentualHoristaSemDesoneracao = 0.0;

  @observable
  totalGeralPercentualMensalistaSemDesoneracao = 0.0;

  @observable
  fetching = false;

  @action.bound
  async obterEncargos() {
    this.fetching = true;

    try {
      this.encargos = [];

      const result = await Configuracao.obterEncargos();
      if (result && result.erro) {
        return error(result.erro);
      }

      this.encargos = [].concat(result);

      this.calcularTotais();
    } finally {
      this.fetching = false;
    }
  }

  calcularTotais() {
    const lista = new Map();
    let nome = "";

    this.encargos.forEach(e => {
      if (e.grupo !== nome) {
        const grupo = {
          nome: e.grupo,
          encargos: [],
          totalPercentualHoristaComDesoneracao: 0,
          totalPercentualMensalistaComDesoneracao: 0,
          totalPercentualHoristaSemDesoneracao: 0,
          totalPercentualMensalistaSemDesoneracao: 0
        };

        lista.set(e.grupo, grupo);
      }

      const grupo = lista.get(e.grupo);
      grupo.totalPercentualHoristaComDesoneracao += e.percentualHoristaComDesoneracao || 0;
      grupo.totalPercentualMensalistaComDesoneracao += e.percentualMensalistaComDesoneracao || 0;
      grupo.totalPercentualHoristaSemDesoneracao += e.percentualHoristaSemDesoneracao || 0;
      grupo.totalPercentualMensalistaSemDesoneracao += e.percentualMensalistaSemDesoneracao || 0;

      e = this.obterValoresConvertidos(e);
      grupo.encargos.push(e);

      nome = e.grupo;
    });

    const array = [];
    lista.forEach(grupo => {
      array.push(grupo);
    });

    this.grupos = array;

    this.calcularTotaisGerais();
  }

  obterValoresConvertidos(encargo) {
    return {
      ...encargo,
      percentualHoristaComDesoneracao: encargo.percentualHoristaComDesoneracao != null ? encargo.percentualHoristaComDesoneracao : "Não incide",
      percentualMensalistaComDesoneracao:
        encargo.percentualMensalistaComDesoneracao != null ? encargo.percentualMensalistaComDesoneracao : "Não incide",
      percentualHoristaSemDesoneracao: encargo.percentualHoristaSemDesoneracao != null ? encargo.percentualHoristaSemDesoneracao : "Não incide",
      percentualMensalistaSemDesoneracao:
        encargo.percentualMensalistaSemDesoneracao != null ? encargo.percentualMensalistaSemDesoneracao : "Não incide"
    };
  }

  calcularTotaisGerais() {
    this.totalGeralPercentualHoristaComDesoneracao = 0;
    this.totalGeralPercentualMensalistaComDesoneracao = 0;
    this.totalGeralPercentualHoristaSemDesoneracao = 0;
    this.totalGeralPercentualMensalistaSemDesoneracao = 0;
    let totalPHCDA = 0;
    let totalPMCDA = 0;
    let totalPHSDA = 0;
    let totalPMSDA = 0;
    let totalPHCDB = 0;
    let totalPMCDB = 0;
    let totalPHSDB = 0;
    let totalPMSDB = 0;
    let percentualHCDA8 = 0;
    let percentualMCDA8 = 0;
    let percentualHSDA8 = 0;
    let percentualMSDA8 = 0;
    let percentualHCDC1 = 0;
    let percentualMCDC1 = 0;
    let percentualHSDC1 = 0;
    let percentualMSDC1 = 0;
    let percentualHCDC2 = 0;
    let percentualMCDC2 = 0;
    let percentualHSDC2 = 0;
    let percentualMSDC2 = 0;

    this.grupos.forEach(grupo => {
      if (grupo.nome === "A") {
        totalPHCDA = grupo.totalPercentualHoristaComDesoneracao;
        totalPMCDA = grupo.totalPercentualMensalistaComDesoneracao;
        totalPHSDA = grupo.totalPercentualHoristaSemDesoneracao;
        totalPMSDA = grupo.totalPercentualMensalistaSemDesoneracao;
        grupo.encargos.forEach(e => {
          if (e.codigo === 8) {
            percentualHCDA8 = e.percentualHoristaComDesoneracao;
            percentualMCDA8 = e.percentualMensalistaComDesoneracao;
            percentualHSDA8 = e.percentualHoristaSemDesoneracao;
            percentualMSDA8 = e.percentualMensalistaSemDesoneracao;
          }
        });
      } else if (grupo.nome === "B") {
        totalPHCDB = grupo.totalPercentualHoristaComDesoneracao;
        totalPMCDB = grupo.totalPercentualMensalistaComDesoneracao;
        totalPHSDB = grupo.totalPercentualHoristaSemDesoneracao;
        totalPMSDB = grupo.totalPercentualMensalistaSemDesoneracao;
      } else if (grupo.nome === "C") {
        grupo.encargos.forEach(e => {
          if (e.codigo === 1) {
            percentualHCDC1 = e.percentualHoristaComDesoneracao;
            percentualMCDC1 = e.percentualMensalistaComDesoneracao;
            percentualHSDC1 = e.percentualHoristaSemDesoneracao;
            percentualMSDC1 = e.percentualMensalistaSemDesoneracao;
          } else if (e.codigo === 2) {
            percentualHCDC2 = e.percentualHoristaComDesoneracao;
            percentualMCDC2 = e.percentualMensalistaComDesoneracao;
            percentualHSDC2 = e.percentualHoristaSemDesoneracao;
            percentualMSDC2 = e.percentualMensalistaSemDesoneracao;
          }
        });
      }

      if (grupo.nome === "D") {
        grupo.encargos.forEach(e => {
          if (e.codigo === 1) {
            e.percentualHoristaComDesoneracao = (totalPHCDA * totalPHCDB) / 100;
            e.percentualMensalistaComDesoneracao = (totalPMCDA * totalPMCDB) / 100;
            e.percentualHoristaSemDesoneracao = (totalPHSDA * totalPHSDB) / 100;
            e.percentualMensalistaSemDesoneracao = (totalPMSDA * totalPMSDB) / 100;
          } else if (e.codigo === 2) {
            e.percentualHoristaComDesoneracao = percentualHCDC1 + percentualHCDA8 + (percentualHCDC2 * totalPHCDA) / 100;
            e.percentualMensalistaComDesoneracao = percentualMCDC1 + percentualMCDA8 + (percentualMCDC2 * totalPMCDA) / 100;
            e.percentualHoristaSemDesoneracao = percentualHSDC1 + percentualHSDA8 + (percentualHSDC2 * totalPHSDA) / 100;
            e.percentualMensalistaSemDesoneracao = percentualMSDC1 + percentualMSDA8 + (percentualMSDC2 * totalPMSDA) / 100;
          }
        });
      }

      this.totalGeralPercentualHoristaComDesoneracao += grupo.totalPercentualHoristaComDesoneracao;
      this.totalGeralPercentualMensalistaComDesoneracao += grupo.totalPercentualMensalistaComDesoneracao;
      this.totalGeralPercentualHoristaSemDesoneracao += grupo.totalPercentualHoristaSemDesoneracao;
      this.totalGeralPercentualMensalistaSemDesoneracao += grupo.totalPercentualMensalistaSemDesoneracao;
    });
  }

  @action.bound
  async salvar() {
    try {
      this.fetching = true;

      const quadro = await Configuracao.atualizarEncargos(this.encargos);
      if (quadro.erro) {
        return error(quadro.erro);
      }

      success("Composição atualizada com sucesso!");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleChange = () => {
    this.verificador = true;
  };

  @action.bound
  handleBlur = ({ target }) => {
    if (this.verificador) {
      const { name, value } = target;
      const valor = util.remover(value);

      const [nome, id] = name.split("-");
      this.encargos.forEach((e, i) => {
        if (e.id === Number.parseInt(id, 0)) {
          e[nome] = valor;
        }
      });

      this.calcularTotais();
      this.verificador = false;
    }
  };
}

export default new EncargosSociaisMaoObraStore();



// WEBPACK FOOTER //
// ./src/views/configuracoes/stores/EncargosSociaisMaoObraStore.js